import React from "react";
import DOMPurify from "dompurify";
import $ from "jquery";

const SANITIZE_CFG = { ALLOWED_TAGS: ["em", "b", "strong", "mark"] };
const allowedHost = $('meta[name="siteDomain"]').attr("content");

function isAllowedUrl(raw) {
  try {
    const u = new URL(String(raw || ""), window.location.origin);
    if (!/^https?:$/i.test(u.protocol)) return false;
    if (allowedHost && u.hostname !== allowedHost && u.hostname !== window.location.hostname) return false;
    return true;
  } catch {
    return false;
  }
}

export default function ResultView({ result }) {
  if (!isAllowedUrl(result?.url?.raw)) {
    return null;
  }

  const url = new URL(String(result.url.raw), window.location.origin).toString();

  if (allowedHost && result?.url_host?.raw && result.url_host.raw !== allowedHost) {
    return null;
  }

  const titleHtml =
    result?.title?.snippet ??
    (result?.title?.raw ? DOMPurify.sanitize(result.title.raw, SANITIZE_CFG) : "ללא כותרת");

  const subtitleHtml =
    result?.meta_description?.snippet ??
    (result?.meta_description?.raw
      ? DOMPurify.sanitize(result.meta_description.raw, SANITIZE_CFG)
      : "");

  return (
    <li className="sui-result">
      <div className="sui-result__header">
        <span className="sui-result__title" />
        <a
          className="sui-result__title sui-result__title-link"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(titleHtml, SANITIZE_CFG) }}
        />
      </div>

      <div className="sui-result__body">
        <ul className="sui-result__details">
          {subtitleHtml && (
            <li>
              <span
                className="sui-result__value"
                style={{ fontSize: "14px", lineHeight: "20px", color: "#666" }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(subtitleHtml, SANITIZE_CFG)
                }}
              />
            </li>
          )}
        </ul>
      </div>
    </li>
  );
}
